/* unplugin-vue-components disabled */import { render } from "./newMusic.vue?vue&type=template&id=6cc7d84c&ts=true"
import script from "./newMusic.vue?vue&type=script&lang=ts"
export * from "./newMusic.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/home/cpns/newMusic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cc7d84c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cc7d84c', __exports__)) {
    console.log('reload')
    api.reload('6cc7d84c', __exports__)
  }
  
  module.hot.accept("./newMusic.vue?vue&type=template&id=6cc7d84c&ts=true", () => {
    console.log('re-render')
    api.rerender('6cc7d84c', render)
  })

}


export default __exports__